// Backend error codes surfaced on `extensions.code`. These are backend
// contracts — don't rename the values.
export const API_ERROR_CODES = {
  // Returned when the explorer service cannot reach the customer's database —
  // connection limit reached, out of memory, restarting, etc. These are
  // conditions the user can observe or resolve themselves, and the accompanying
  // error message is authored by the backend for users (e.g. "your service has
  // reached its connection limit"), so it is safe to display verbatim.
  EXPLORER_PG_UNAVAILABLE: "EXPLORER_PG_UNAVAILABLE",
  // Forwarded on any 5xx from FusionAuth (our auth provider).
  FUSIONAUTH_DOWN_CODE: "fusionauth_down",
} as const;

// `reason` values carried in the URL to the /idpError screen so it can pick the
// right copy. Frontend-owned, unlike FUSIONAUTH_DOWN_CODE above.
export const idpErrorReasons = {
  AUTH_SERVICE_DOWN: "auth_service_down",
  IDP_LOGIN_FAILED: "idp_login_failed",
} as const;

export type IdpErrorReasons =
  (typeof idpErrorReasons)[keyof typeof idpErrorReasons];

// The client timeout for the services list. The value is 40s, so the backend
// timeout (about 30s) occurs first and returns a real error. Without this, the
// client ApolloLinkTimeout occurs first and looks like a network problem. See
// isSlowNetworkError.
export const SERVICES_QUERY_TIMEOUT_MS = 40 * 1000;

// The interval to poll a single service while its state changes.
export const SERVICE_POLL_INTERVAL_MS = 5 * 1000;
